import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import { FullwidthImage, ContactFormFullwidth } from 'components';
import { enableAnimations } from 'config/helpers';
import {
  Banner,
  What,
  Why,
  Technologies,
  Problem,
  Solution,
  Types,
  Benefits,
  ProcessAndTools,
  OurArticles,
  OtherServices,
} from './subcomponents';
import './DigitalTransformation.scss';

class DigitalTransformation extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { allArticles } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query {
            teamImage: file(
              relativePath: {
                eq: "office/development-team-discuss-performance.jpg"
              }
            ) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div
            className={'single-page single-page--hero digital-transformation'}
          >
            <Banner />
            <What />
            <LazyLoad offset={200}>
              <Why />
            </LazyLoad>
            <LazyLoad offset={200}>
              <Technologies />
            </LazyLoad>
            <Problem />
            <LazyLoad offset={200}>
              <FullwidthImage image={data.teamImage.childImageSharp.fluid} />
            </LazyLoad>
            <Solution />
            <Types allArticles={allArticles} />
            <Benefits />
            <LazyLoad offset={200}>
              <ProcessAndTools />
            </LazyLoad>
            <ContactFormFullwidth
              name={'digital-transformation-contact-form'}
              pardotLink={'https://go.boldare.com/l/688533/2019-02-28/x87'}
            />
            <OurArticles allArticles={allArticles} />
            <OtherServices />
          </div>
        )}
      />
    );
  }
}

export default DigitalTransformation;
